/**
 * Radio Group Renderer
 * Features: radio button group with multiple options
 */
import React from 'react';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import type { FieldRenderer } from '@/MyCode/core';

export const renderRadio: FieldRenderer = ({
    field,
    value,
    hasError,
    handleChange,
    isRequired
}) => (
    <div className="space-y-2">
        <Label>
            {field.label}
            {isRequired && <span className="text-destructive ml-1">*</span>}
        </Label>
        <RadioGroup
            value={value === undefined ? undefined : (value as any)}
            onValueChange={(val) => handleChange(field.name, val)}
            className={hasError ? 'border border-destructive rounded-md p-2' : ''}
        >
            {field.options?.items?.map((option) => (
                <div key={option.value} className="flex items-center space-x-2">
                    <RadioGroupItem value={option.value} id={`${field.name}-${option.value}`} />
                    <Label htmlFor={`${field.name}-${option.value}`} className="font-normal">
                        {option.label}
                    </Label>
                </div>
            ))}
        </RadioGroup>
    </div>
);

export default renderRadio;